import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Organization Stats Config"})
export default class OrganizationStatsConfig {

	@Input({type: InputType.CHECKBOX, title: "Show User Count"})
	public showUserCount: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Show Discussion Topic Count"})
	public showDiscussionCount: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Show Course Count"})
	public showCourseCount: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Vertical"})
	public vertical: boolean = true;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/stats/OrganizationStatsConfig.ts